const matrixMixin = {

    props: {
        columns: Array,
        headerTitle: String,
        columnGroup: String,
    },

    methods: {

        changeValue(value, row, col)
        {
            this.dispatchChangeAnswer([this.uukey, value, row, col]);
        },

        changeOther($event)
        {
            this.changeValue($event.target.value, 'other');
            this.othervalue = $event.target.value;
        },
    },

};

export { matrixMixin }



// WEBPACK FOOTER //
// ./resources/assets/js/components/vue/mixins/matrix-mixin.js